import React from 'react';
import Layout from '../../components/Layout';
import TripTracking from './TripTracking';

const title = 'Track Trip';

function action({ params }) {
  return {
    title,
    component: (
      <Layout>
        <TripTracking shareToken={params.token} />
      </Layout>
    ),
  };
}

export default action;